<template>
    <div class="page"
         v-loading.fullscreen.lock="fullscreenLoading"
         element-loading-text="加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.5)">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="所属账号">
                <GridSelectU style="width: 200px;" title="选择所属账号" labelName="userName"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                             placeholder='请选择所属账号'
                             @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                             dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                             queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <!--            <el-form-item label="子商户号">-->
            <!--                <el-input v-model="queryForm.subAccount" style="width: 200px;"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="组织类型">
                <el-select v-model="queryForm.orgType" style="width: 200px;">
                    <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :key="index" :value="item.key" :label="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="营业执照名称">
                <el-input style="width: 200px;" v-model="queryForm.licenseName"></el-input>
            </el-form-item>
            <el-form-item label="法人姓名">
                <el-input style="width: 200px;" v-model="queryForm.personName"></el-input>
            </el-form-item>
            <el-form-item label="法人手机">
                <el-input style="width: 200px;" v-model="queryForm.personMobile"></el-input>
            </el-form-item>
            <el-form-item label="是否签约">
                <el-select v-model="queryForm.isSign" style="width: 200px;">
                    <el-option :value="1" label="是"></el-option>
                    <el-option :value="0" label="否"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreInfoList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="content">
            <div class="page-tool-bar" style="padding: 10px">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addShopStoreInfo"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopStoreInfo(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopStoreInfo(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                      <Icon color="#606266">
                        <Search />
                      </Icon>
                    </span>
<!--                    <span-->
<!--                        title="下载模板"-->
<!--                        class="icon-box"-->
<!--                        @click="importTemplate"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <ArrowDown />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        class="icon-box"-->
<!--                        title="导入数据"-->
<!--                        @click="isImport"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <ArrowExportUp24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        title="导出数据"-->
<!--                        class="icon-box"-->
<!--                        @click="exportShopStoreInfoList"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <ArrowDownload24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
                    <span
                        class="icon-box"
                        @click="refreshShopStoreInfoList"
                    >
                  <Icon color="#606266">
                    <Refresh />
                  </Icon>
                </span>
                </div>
            </div>
            <div class="page-content">
                <!-- 列表数据 -->
                <!--            tab-->
                <el-tabs v-model="tabs" v-if='auditStatusList.length > 0'>

                    <!--添加或减少：移除或添加html结构->移除或添加监听的tabs中switch case
                        修改默认显示：tab栏默认显示tabs的值 想默认显示那个直接把下面的name替换掉
                        queryForm.orderStatus的值为默认请求的类型，空表示全部-->
                    <el-tab-pane label="" name="null"></el-tab-pane>
                    <el-tab-pane :label="'全部'" name="zero"></el-tab-pane>
                    <!--                (${computeAuditStatus[`status_${index}`]})-->
                    <el-tab-pane v-for="(item,index) in auditStatusList" :label="`${item.value}`" :name='"status_"+index'></el-tab-pane>
                </el-tabs>
                <el-table
                    :data="shopStoreInfoList"
                    row-key="id"
                    border
                    height="100%"
                    :header-row-style="{height: '10px', 'margin-top': '0px'}"
                    :header-cell-style="{padding: '10px'}"
                    :row-style="{height: '9px'}"
                    @selection-change="handleSelectionChange"
                    size="small"
                >
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="orgType"
                        label="组织类型"
                        width="100%"
                    >
                        <template scope="scope">
                            <div v-if="storeOrgTypeStatusEunmList && scope.row.orgType">
                                <el-tag size="small" type="danger" v-if="scope.row.orgType == 3">{{returnStoreOrgTypeStatus(scope.row.orgType)}}</el-tag>
                                <el-tag size="small" v-else>{{returnStoreOrgTypeStatus(scope.row.orgType)}}</el-tag>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop=""
                        label="门店信息"
                        width="230"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.store">
                                <div style="text-align: left">店名：{{scope.row.store.storeName}}</div>
                                <div style="text-align: left">时间：{{scope.row.store.openHours}}</div>
                                <div style="text-align: left">地址：{{scope.row.store.storeAddress}}</div>
                            </div>
                            <div v-else>暂无关联店铺</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop=""
                        label="用户信息"
                        width="230"
                    >
                        <template scope="scope">
                            <div v-if="scope.row.user">
                                <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                                <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                                <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                            </div>
                            <div v-else>暂无关联用户</div>
                        </template>
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        :show-overflow-tooltip="true"-->
<!--                        align="center"-->
<!--                        prop=""-->
<!--                        label="工商信息"-->
<!--                        width="230"-->
<!--                    >-->
<!--                        <template scope="scope">-->
<!--                            <div>-->
<!--                                <div style="text-align: left">法人：{{ scope.row.personName }}</div>-->
<!--                                <div style="text-align: left">法人手机号：{{ scope.row.personMobile }}</div>-->
<!--                                <div style="text-align: left">营业执照名称：{{ scope.row.licenseName }}</div>-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                        :show-overflow-tooltip="true"-->
<!--                        align="center"-->
<!--                        prop=""-->
<!--                        label="银行信息"-->
<!--                        width="230"-->
<!--                    >-->
<!--                        <template scope="scope">-->
<!--                            <div>-->
<!--                                <div style="text-align: left">银行户名：{{ scope.row.bankHolder }}</div>-->
<!--                                <div style="text-align: left">银行账号：{{ scope.row.bankAccount }}</div>-->
<!--                                <div style="text-align: left">开户行：{{ scope.row.bankSubbranch }}</div>-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column :show-overflow-tooltip="true" align="center" label="银盛支付审核状态" width="170">
                        <template slot-scope="scope">
                            <div>
                                <span :class="{'active': scope.row.yinshengMerch && scope.row.yinshengMerch.thirdStatus == 4}">{{returnStoreOrgStatus(scope.row.yinshengMerch ? scope.row.yinshengMerch.thirdStatus : 0)}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center"  label="审核状态" width="200">
                        <template slot-scope="scope">

                            <!--                        <div style="text-align: left">银盛支付审核状态：<span :class="{'active': scope.row.thirdStatus == 2}">{{computeAuditStatus(scope.row.thirdStatus) }}</span></div>-->
                            <div style="text-align: left">微信支付认证状态：<span :class="{'active': scope.row.yinshengMerch && scope.row.yinshengMerch.openWxpay}">{{ scope.row.yinshengMerch && scope.row.yinshengMerch.openWxpay == 1 ? '已认证' : '未认证' }}</span></div>
                            <div style="text-align: left">支付宝支付认证状态：<span :class="{'active': scope.row.yinshengMerch && scope.row.yinshengMerch.openAlipay}">{{ scope.row.yinshengMerch && scope.row.yinshengMerch.openAlipay == 1 ? '已认证' : '未认证' }}</span></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="resultMsg"
                        label="响应报文"
                        width="180"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.yinshengMerch && scope.row.yinshengMerch.resultMsg}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" label="审核失败原因" width="170">
                        <template slot-scope="scope">
                            <div v-if="scope.row.store.status == 3">
                                <span>{{scope.row.store.refuseReason}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="licensePic"
                        label="营业执照"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.licensePic'>
                                <el-image
                                    @click='updateSrcList(scope.row.licensePic)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.licensePic"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="bankCardFacade"
                        label="银行卡正面图片"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.bankCardFacade'>
                                <el-image
                                    @click='updateSrcList(scope.row.bankCardFacade)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.bankCardFacade"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="bankAccountVoucher"
                        label="对公账户凭证"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.bankAccountVoucher'>
                                <el-image
                                    @click='updateSrcList(scope.row.bankAccountVoucher)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.bankAccountVoucher"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="idCardFacade"
                        label="身份证正面"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.idCardFacade'>
                                <el-image
                                    @click='updateSrcList(scope.row.idCardFacade)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.idCardFacade"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="idCardBack"
                        label="身份证背面"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.idCardBack'>
                                <el-image
                                    @click='updateSrcList(scope.row.idCardBack)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.idCardBack"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="wxpayConfirmQrcode"
                        label="微信确认二维码"
                        width="130"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.yinshengMerch && scope.row.yinshengMerch.wxpayConfirmQrcode'>
                                <el-image
                                    @click='updateSrcList(scope.row.yinshengMerch.wxpayConfirmQrcode)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.yinshengMerch.wxpayConfirmQrcode"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else-if="scope.row.yinshengMerch && scope.row.yinshengMerch.wxpayAuthStatus == 5">驳回，请查看报文</div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="alipayConfirmQrcode"
                        label="支付宝确认二维码"
                        width="144"
                    >
                        <template slot-scope="scope">
                            <div v-if='scope.row.yinshengMerch && scope.row.yinshengMerch.alipayConfirmQrcode'>
                                <el-image
                                    @click='updateSrcList(scope.row.yinshengMerch.alipayConfirmQrcode)'
                                    style="width: 60px; height: 60px"
                                    :src="scope.row.yinshengMerch.alipayConfirmQrcode"
                                    :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else-if="scope.row.yinshengMerch && scope.row.yinshengMerch.alipayAuthStatus == 5">驳回，请查看报文</div>
                            <div v-else>-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        align="center"
                        label="操作"
                        width="380"
                    >
                        <template slot-scope="scop">
                            <div class="operation">
                                <div @click='ShopStoreAudit(scop.row)' v-if='scop.row.store.status == 1'>
                                    <el-button type='primary' size='mini'>审核</el-button>
                                </div>
                                <div @click="checkShopStoreInfo(scop.row.id)">
                                    <Icon size="16">
                                        <Eye24Regular />
                                    </Icon>
                                    <span class="operation-label">查看</span>
                                </div>
                                <div @click="editShopStoreInfo(scop.row.id)">
                                    <Icon size="16">
                                        <Edit24Regular />
                                    </Icon>
                                    <span class="operation-label">修改</span>
                                </div>
                                <div @click="deleteShopStoreInfo(scop.row.id)">
                                    <Icon size="16" style="color: red">
                                        <Delete24Regular />
                                    </Icon>
                                    <span class="operation-label" style="color: red">删除</span>
                                </div>
                            </div>
                            <div class="operation">
                                <div @click="submitMerchantInfo(scop.row.storeId)" v-if="scop.row.yinshengMerch && scop.row.yinshengMerch.thirdStatus == 0">
                                    <span class="operation-label">提交进件</span>
                                </div>
<!--                                <div @click="editMerchantInfo(scop.row.storeId)" v-if="scop.row.yinshengMerch && scop.row.yinshengMerch.thirdStatus == 1">-->
<!--                                    <span class="operation-label">提交修改资料</span>-->
<!--                                </div>-->
<!--                                <div @click="applyElectronContract(scop.row.storeId)" v-if="scop.row.yinshengMerch && scop.row.yinshengMerch.thirdStatus == 2">-->
<!--                                    <span class="operation-label">申请签约</span>-->
<!--                                </div>-->
<!--                                <div @click="getMerchantInfo(scop.row.storeId)" v-if="scop.row.yinshengMerch && scop.row.yinshengMerch.thirdStatus == 4">-->
<!--                                    <span class="operation-label">同步数据</span>-->
<!--                                </div>-->
<!--                                <div @click="changeMerchantBank(scop.row.storeId)" v-if="scop.row.yinshengMerch && scop.row.yinshengMerch.thirdStatus == 4">-->
<!--                                    <span class="operation-label">银行变更</span>-->
<!--                                </div>-->
<!--                                <div @click="changeMerchantInfo(scop.row.storeId)" v-if="scop.row.yinshengMerch && scop.row.yinshengMerch.thirdStatus == 4">-->
<!--                                    <span class="operation-label">商户变更</span>-->
<!--                                </div>-->
<!--                                <div @click="merchantNonmemberAdd(scop.row.storeId)" v-if="scop.row.yinshengMerch && scop.row.yinshengMerch.thirdStatus == 4">-->
<!--                                    <span class="operation-label">分账录入</span>-->
<!--                                </div>-->
<!--                                <div @click="closedMerchant(scop.row.storeId, scop.row.licenseName)" v-if="scop.row.yinshengMerch && scop.row.yinshengMerch.thirdStatus == 4">-->
<!--                                    <span class="operation-label">注销商户</span>-->
<!--                                </div>-->
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopStoreInfoStates[shopStoreInfoState]"
                :visible.sync="showDialog"
                width="1200px"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopStoreInfo"
                        ref="shopStoreInfoForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-tabs type="border-card">
                            <el-tab-pane label="工商信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">本地信息</span>
                                        </div>
                                        <el-form-item
                                            label="组织类型"
                                            prop="orgType"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.orgType"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-select
                                                v-model="shopStoreInfo.orgType"
                                                size="small"
                                                placeholder="请选择组织类型"
                                                clearable
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                            >
                                                <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :label="item.value" :value="item.key"> </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照注册省份"
                                            prop="licenseProvinceId"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.licenseProvinceId"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                v-model='shopStoreInfo.licenseProvinceId'
                                                size='small'
                                                placeholder='请选择省份'
                                            >
                                                <el-option
                                                    v-for='item in provinceIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照注册城市"
                                            prop="licenseCityId"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.licenseCityId"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                v-model='shopStoreInfo.licenseCityId'
                                                size='small'
                                                placeholder='请选择城市'
                                            >
                                                <el-option
                                                    v-for='(item, index) in cityIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照注册区域"
                                            prop="licenseAreaId"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.licenseAreaId"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                v-model='shopStoreInfo.licenseAreaId'
                                                size='small'
                                                placeholder='请选择区县'
                                            >
                                                <el-option
                                                    v-for='(item, index) in areaIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照注册社区"
                                            prop="licenseTownId"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.licenseTownId"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                v-model='shopStoreInfo.licenseTownId'
                                                size='small'
                                                placeholder='请选择乡镇'
                                            >
                                                <el-option
                                                    v-for='(item, index) in streetIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照名称"
                                            prop="licenseName"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                v-model="shopStoreInfo.licenseName"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照注册地址"
                                            prop="licenseAddress"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                v-model="shopStoreInfo.licenseAddress"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="统一社会信用代码"
                                            prop="licenseNumber"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                v-model="shopStoreInfo.licenseNumber"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
<!--                                        <el-form-item-->
<!--                                            label="营业执照是否长期有效"-->
<!--                                            prop="licenseIsPermanent"-->
<!--                                        >-->
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.licenseIsPermanent"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
<!--                                        </el-form-item>-->
                                        <el-form-item
                                            label="营业执照有效开始日期"
                                            prop="licenseStartTime"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.licenseStartTime"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="width: 200px;display: flex;align-items: center;">
                                                <el-date-picker
                                                    style="width: 200px"
                                                    :disabled="shopStoreInfoState == 'check'"
                                                    size="small"
                                                    v-model="shopStoreInfo.licenseStartTime"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="选择日期">
                                                </el-date-picker>
                                                <el-checkbox style="margin-left: 10px" :disabled="shopStoreInfoState == 'check'" :true-label="1" :false-label="0" v-model="shopStoreInfo.licenseIsPermanent" label="长期"></el-checkbox>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照有效结束日期"
                                            prop="licenseEndTime"
                                            v-if="shopStoreInfo.licenseIsPermanent == 0"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.licenseEndTime"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-date-picker
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                size="small"
                                                v-model="shopStoreInfo.licenseEndTime"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="选择日期">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照经营范围"
                                            prop="licenseRange"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.licenseRange"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-input
                                                size="small"
                                                type="textarea"
                                                :rows="8"
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                v-model="shopStoreInfo.licenseRange"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="营业执照图片"
                                            prop="licensePic"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.licensePic"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="width: 200px;display: flex;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage21">
                                                    <img v-if="shopStoreInfo.licensePic" :src="shopStoreInfo.licensePic" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.licensePic)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="right" style="flex: 1;flex-shrink: 0;margin-left: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">银盛信息</span>
                                        </div>
<!--                                        <el-form-item-->
<!--                                            label="行业代码"-->
<!--                                            prop="yinshengMerch.mccCode"-->
<!--                                        >-->
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                style="width: 200px"-->
<!--                                                readonly-->
<!--                                                v-model="shopStoreInfo.yinshengMerch.mccName"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            >-->
<!--                                                <el-button @click="getMccCode()" slot="append" icon="el-icon-search"></el-button>-->
<!--                                            </el-input>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                            label="收单机构对应的省"-->
<!--                                            prop="yinshengMerch.acqProvinceId"-->
<!--                                        >-->
<!--                                            <el-select-->
<!--                                                style='width:200px'-->
<!--                                                v-model='shopStoreInfo.yinshengMerch.acqProvinceId'-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                                size='small'-->
<!--                                                placeholder='请选择省份'-->
<!--                                            >-->
<!--                                                <el-option-->
<!--                                                    v-for='(item, index) in provinceIdList3'-->
<!--                                                    :key='item.id'-->
<!--                                                    :label='item.name'-->
<!--                                                    :value='item.code'-->
<!--                                                ></el-option>-->
<!--                                            </el-select>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                            label="收单机构对应的市"-->
<!--                                            prop="yinshengMerch.acqCityId"-->
<!--                                        >-->
<!--                                            <el-select-->
<!--                                                style='width:200px'-->
<!--                                                v-model='shopStoreInfo.yinshengMerch.acqCityId'-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                                size='small'-->
<!--                                                placeholder='请选择城市'-->
<!--                                            >-->
<!--                                                <el-option-->
<!--                                                    v-for='(item, index) in cityIdList3'-->
<!--                                                    :key='item.code + index'-->
<!--                                                    :label='item.name'-->
<!--                                                    :value='item.code'-->
<!--                                                ></el-option>-->
<!--                                            </el-select>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                            label="收单机构对应的区"-->
<!--                                            prop="yinshengMerch.acqAreaId"-->
<!--                                        >-->
<!--                                            <el-select-->
<!--                                                style='width:200px'-->
<!--                                                v-model='shopStoreInfo.yinshengMerch.acqAreaId'-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                                size='small'-->
<!--                                                placeholder='请选择区县'-->
<!--                                            >-->
<!--                                                <el-option-->
<!--                                                    v-for='(item, index) in areaIdList3'-->
<!--                                                    :key='item.id'-->
<!--                                                    :label='item.name'-->
<!--                                                    :value='item.code'-->
<!--                                                ></el-option>-->
<!--                                            </el-select>-->
<!--                                        </el-form-item>-->
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="法人信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">本地信息</span>
                                        </div>
                                        <el-form-item
                                            label="法人姓名"
                                            prop="personName"
                                        >
                                            <el-input
                                                size="small"
                                                style='width:200px'
                                                v-model="shopStoreInfo.personName"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="法人手机"
                                            prop="personMobile"
                                        >
                                            <el-input
                                                size="small"
                                                style='width:200px'
                                                v-model="shopStoreInfo.personMobile"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="身份证号"
                                            prop="idCard"
                                        >
                                            <el-input
                                                size="small"
                                                style='width:200px'
                                                v-model="shopStoreInfo.idCard"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
<!--                                        <el-form-item-->
<!--                                            label="身份证是否长期有效：1是 0否 "-->
<!--                                            prop="idCardIsPermanent"-->
<!--                                        >-->
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.idCardIsPermanent"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
<!--                                        </el-form-item>-->
                                        <el-form-item
                                            label="身份证有效限期起始日期"
                                            prop="idCardStartTime"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.idCardStartTime"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="width: 200px;display: flex;align-items: center">
                                                <el-date-picker
                                                    style="flex: 1"
                                                    size="small"
                                                    :disabled="shopStoreInfoState == 'check'"
                                                    v-model="shopStoreInfo.idCardStartTime"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="选择日期">
                                                </el-date-picker>
                                                <el-checkbox style="margin-left: 10px" :disabled="shopStoreInfoState == 'check'" :true-label="1" :false-label="0" v-model="shopStoreInfo.idCardIsPermanent" label="长期"></el-checkbox>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="身份证有效期限截止日期"
                                            prop="idCardEndTime"
                                            v-if="shopStoreInfo.idCardIsPermanent == 0"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.idCardEndTime"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-date-picker
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                size="small"
                                                v-model="shopStoreInfo.idCardEndTime"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="选择日期">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item
                                            label="身份证地址"
                                            prop="idCardAddress"
                                        >
                                            <el-input
                                                size="small"
                                                style='width:200px'
                                                v-model="shopStoreInfo.idCardAddress"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="身份证正面图片"
                                            prop="idCardFacade"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.idCardFacade"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage31">
                                                    <img v-if="shopStoreInfo.idCardFacade" :src="shopStoreInfo.idCardFacade" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.idCardFacade)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="身份证背面图片"
                                            prop="idCardBack"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.idCardBack"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage32">
                                                    <img v-if="shopStoreInfo.idCardBack" :src="shopStoreInfo.idCardBack" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.idCardBack)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="银行信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">本地信息</span>
                                        </div>
                                        <el-form-item
                                            label="银行户主"
                                            prop="bankHolder"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px;"
                                                v-model="shopStoreInfo.bankHolder"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行账号"
                                            prop="bankAccount"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px;"
                                                v-model="shopStoreInfo.bankAccount"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行名称"
                                            prop="bankName"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px;"
                                                v-model="shopStoreInfo.bankName"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="开户支行名称"
                                            prop="bankSubbranch"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px;"
                                                v-model="shopStoreInfo.bankSubbranch"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="行联号"
                                            prop="bankBranchCode"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px;"
                                                v-model="shopStoreInfo.bankBranchCode"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="开户银行省份"
                                            prop="bankProvinceId"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.bankProvinceId"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                v-model='shopStoreInfo.bankProvinceId'
                                                size='small'
                                                placeholder='请选择省份'
                                            >
                                                <el-option
                                                    v-for='(item, index) in provinceIdList'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="开户银行城市"
                                            prop="bankCityId"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.bankCityId"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                v-model='shopStoreInfo.bankCityId'
                                                size='small'
                                                placeholder='请选择城市'
                                            >
                                                <el-option
                                                    v-for='(item, index) in cityIdList2'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="开户银行区县"
                                            prop="bankAreaId"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.bankAreaId"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-select
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                                v-model='shopStoreInfo.bankAreaId'
                                                size='small'
                                                placeholder='请选择区县'
                                            >
                                                <el-option
                                                    v-for='(item, index) in areaIdList2'
                                                    :key='item.id'
                                                    :label='item.name'
                                                    :value='item.id'
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
<!--                                        <el-form-item-->
<!--                                            label="开户银行社区"-->
<!--                                            prop="bankTownId"-->
<!--                                        >-->
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.bankTownId"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
<!--                                        </el-form-item>-->
                                        <el-form-item
                                            label="银行预留手机号码"
                                            prop="bankMobile"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px;"
                                                v-model="shopStoreInfo.bankMobile"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行卡正面图片"
                                            prop="bankCardFacade"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.bankCardFacade"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage41">
                                                    <img v-if="shopStoreInfo.bankCardFacade" :src="shopStoreInfo.bankCardFacade" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.bankCardFacade)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="银行卡背面图片"
                                            prop="bankCardBack"
                                            v-if="shopStoreInfo.orgType != 2"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.bankCardBack"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage42">
                                                    <img v-if="shopStoreInfo.bankCardBack" :src="shopStoreInfo.bankCardBack" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.bankCardBack)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="对公账户凭证"
                                            prop="bankAccountVoucher"
                                            v-if="shopStoreInfo.orgType == 2"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.bankAccountVoucher"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage43">
                                                    <img v-if="shopStoreInfo.bankAccountVoucher" :src="shopStoreInfo.bankAccountVoucher" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.bankAccountVoucher)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="right" style="flex: 1;flex-shrink: 0;margin-left: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">银盛信息</span>
                                        </div>
<!--                                        <el-form-item-->
<!--                                            label="收单机构银行对应的省"-->
<!--                                            prop="yinshengMerch.acqBankProvinceId"-->
<!--                                        >-->
<!--                                            <el-select-->
<!--                                                style='width:200px'-->
<!--                                                v-model='shopStoreInfo.yinshengMerch.acqBankProvinceId'-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                                size='small'-->
<!--                                                placeholder='请选择省份'-->
<!--                                            >-->
<!--                                                <el-option-->
<!--                                                    v-for='(item, index) in provinceIdList3'-->
<!--                                                    :key='item.id'-->
<!--                                                    :label='item.name'-->
<!--                                                    :value='item.code'-->
<!--                                                ></el-option>-->
<!--                                            </el-select>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                            label="收单机构银行对应的市"-->
<!--                                            prop="yinshengMerch.acqBankCityId"-->
<!--                                        >-->
<!--                                            <el-select-->
<!--                                                style='width:200px'-->
<!--                                                v-model='shopStoreInfo.yinshengMerch.acqBankCityId'-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                                size='small'-->
<!--                                                placeholder='请选择城市'-->
<!--                                            >-->
<!--                                                <el-option-->
<!--                                                    v-for='(item, index) in cityIdList4'-->
<!--                                                    :key='item.id'-->
<!--                                                    :label='item.name'-->
<!--                                                    :value='item.code'-->
<!--                                                ></el-option>-->
<!--                                            </el-select>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                            label="收单机构银行对应的区"-->
<!--                                            prop="yinshengMerch.acqBankAreaId"-->
<!--                                        >-->
<!--                                            <el-select-->
<!--                                                style='width:200px'-->
<!--                                                v-model='shopStoreInfo.yinshengMerch.acqBankAreaId'-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                                size='small'-->
<!--                                                placeholder='请选择区县'-->
<!--                                            >-->
<!--                                                <el-option-->
<!--                                                    v-for='(item, index) in areaIdList4'-->
<!--                                                    :key='item.id'-->
<!--                                                    :label='item.name'-->
<!--                                                    :value='item.code'-->
<!--                                                ></el-option>-->
<!--                                            </el-select>-->
<!--                                        </el-form-item>-->
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="认证信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">银盛信息</span>
                                        </div>
                                        <el-form-item
                                            label="进件状态"
                                            prop="yinshengMerch.thirdStatus"
                                        >
                                            <el-select
                                                v-model="shopStoreInfo.yinshengMerch.thirdStatus"
                                                size="small"
                                                :disabled="shopStoreInfoState == 'check'"
                                                placeholder="请选择进件状态"
                                                clearable
                                                style="width: 200px"
                                            >
                                                <el-option v-for="(item,index) in auditStatusList" :label="item.value" :value="item.key"> </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="第三方支付子商户号"
                                            prop="yinshengMerch.subAccount"
                                        >
                                            <el-input
                                                size="small"
                                                style="width: 200px"
                                                v-model="shopStoreInfo.yinshengMerch.subAccount"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="微信支付开关"
                                            prop="yinshengMerch.openWxpay"
                                        >
                                            <!--                                            <el-input-->
                                            <!--                                                size="small"-->
                                            <!--                                                v-model="shopStoreInfo.yinshengMerch.openWxpay"-->
                                            <!--                                                style="width: 200px"-->
                                            <!--                                                :disabled="shopStoreInfoState == 'check'"-->
                                            <!--                                            ></el-input>-->
                                            <el-select
                                                v-model="shopStoreInfo.yinshengMerch.openWxpay"
                                                :disabled="shopStoreInfoState == 'check'"
                                                size="small"
                                                placeholder="请选择微信支付是否开启"
                                                clearable
                                                style="width: 200px"
                                            >
                                                <el-option label="是" :value="1"> </el-option>
                                                <el-option label="否" :value="0"> </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="微信申请单编号"
                                            prop="yinshengMerch.wxpayApplyNo"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStoreInfo.yinshengMerch.wxpayApplyNo"
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="微信商户号"
                                            prop="yinshengMerch.wxpayMerchNo"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStoreInfo.yinshengMerch.wxpayMerchNo"
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="微信法人确认二维码"
                                            prop="yinshengMerch.wxpayConfirmQrcode"
                                        >
                                            <div style="display:flex;width: 200px;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage52">
                                                    <img v-if="shopStoreInfo.yinshengMerch.wxpayConfirmQrcode" :src="shopStoreInfo.yinshengMerch.wxpayConfirmQrcode" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.yinshengMerch.wxpayConfirmQrcode)">查看</el-button>
                                            </div>

                                        </el-form-item>

                                        <el-form-item
                                            label="支付宝支付开关"
                                            prop="yinshengMerch.openAlipay"
                                        >
                                            <el-select
                                                v-model="shopStoreInfo.yinshengMerch.openAlipay"
                                                :disabled="shopStoreInfoState == 'check'"
                                                size="small"
                                                placeholder="请选择支付宝支付是否开启"
                                                clearable
                                                style="width: 200px"
                                            >
                                                <el-option label="是" :value="1"> </el-option>
                                                <el-option label="否" :value="0"> </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="支付宝申请单编号"
                                            prop="yinshengMerch.alipayApplyNo"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStoreInfo.yinshengMerch.alipayApplyNo"
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="支付宝商户号"
                                            prop="yinshengMerch.alipayMerchNo"
                                        >
                                            <el-input
                                                size="small"
                                                v-model="shopStoreInfo.yinshengMerch.alipayMerchNo"
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                            label="支付宝法人确认二维码"
                                            prop="yinshengMerch.alipayConfirmQrcode"
                                        >
                                            <div style="display:flex;width: 200px;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage54">
                                                    <img v-if="shopStoreInfo.yinshengMerch.alipayConfirmQrcode" :src="shopStoreInfo.yinshengMerch.alipayConfirmQrcode" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.yinshengMerch.alipayConfirmQrcode)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="进件日志"
                                            prop="yinshengMerch.resultMsg"
                                        >
                                            <el-input
                                                size="small"
                                                type="textarea"
                                                :rows="8"
                                                style="width: 200px"
                                                v-model="shopStoreInfo.yinshengMerch.resultMsg"
                                                :disabled="shopStoreInfoState == 'check'"
                                            ></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="签约信息">
                                <div style="display: flex">
                                    <div class="left" style="flex: 2;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">本地信息</span>
                                        </div>
                                        <el-form-item
                                            label="是否签名"
                                            prop="isSign"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.isSign"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <el-select
                                                size="small"
                                                v-model="shopStoreInfo.isSign"
                                                style="width: 200px"
                                                :disabled="shopStoreInfoState == 'check'"
                                            >
                                                <el-option :value="0" label="未签约"></el-option>
                                                <el-option :value="1" label="已签约"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item
                                            label="签名图片"
                                            prop="signPic"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.signPic"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage61">
                                                    <img v-if="shopStoreInfo.signPic" :src="shopStoreInfo.signPic" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.signPic)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item
                                            label="合同地址"
                                            prop="contractUrl"
                                        >
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.contractUrl"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
                                            <div style="display: flex;width: 200px;">
                                                <el-upload :disabled="shopStoreInfoState == 'check'" :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                           class="avatar-uploader" :show-file-list="false"
                                                           :http-request="uploadImage62">
                                                    <img v-if="shopStoreInfo.contractUrl" :src="shopStoreInfo.contractUrl" class="avatar" size="small" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreInfo.contractUrl)">查看</el-button>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="right" style="flex: 1;flex-shrink: 0;margin-right: 10px">
                                        <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;border-bottom: 1px solid #ccc; padding-bottom: 8px">
                                            <span style="font-size: 16px;font-weight: 700">银盛信息</span>
                                        </div>
<!--                                        <el-form-item-->
<!--                                            label="收单机构门户网站账号"-->
<!--                                            prop="yinshengMerch.acqPortalAccount"-->
<!--                                        >-->
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.yinshengMerch.acqPortalAccount"-->
<!--                                                style="width: 140px"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
<!--                                            <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getAcqPortalAccount">生成</el-button>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                            label="收单机构门户网站账号邮箱"-->
<!--                                            prop="yinshengMerch.acqPortalEmail"-->
<!--                                        >-->
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.yinshengMerch.acqPortalEmail"-->
<!--                                                style="width: 140px"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
<!--                                            <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getStoreEmail">默认</el-button>-->
<!--                                        </el-form-item>-->
<!--                                        <el-form-item-->
<!--                                            label="收单机构电子协议签约地址"-->
<!--                                            prop="elecAgrmtUrl"-->
<!--                                        >-->
<!--                                            <el-input-->
<!--                                                size="small"-->
<!--                                                v-model="shopStoreInfo.yinshengMerch.elecAgrmtUrl"-->
<!--                                                style="width: 200px"-->
<!--                                                :disabled="shopStoreInfoState == 'check'"-->
<!--                                            ></el-input>-->
<!--                                        </el-form-item>-->
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
<!--                        <el-form-item-->
<!--                            label="其他补充资料：根据行业补充资料也不同，如烟酒店需要烟草经营许可证-废弃"-->
<!--                            prop="otherInfor"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStoreInfo.otherInfor"-->
<!--                                :disabled="shopStoreInfoState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-image ref="images" v-show="false" @click='updateSrcList(imageSrc)' style="width: 60px; height: 60px"
                                  :src="imageSrc" :preview-src-list="srcList"> </el-image>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-self-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopStoreInfoState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
        <!--审核功能-->
        <el-dialog title='审核' :visible.sync='retreatDialogVisible' width='30%'
                   :before-close='handleCloseRetreat'>
            <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='100px'>
                <el-form-item label='申请说明：'>
                    <el-input style='width: 100%' type='textarea' v-model='applyRemarks'
                              :disabled='true'></el-input>
                </el-form-item>
                <el-form-item label='是否同意：' prop='resource'>
                    <el-radio-group v-model='retreatForm.resource'>
                        <el-radio label='true'>同意</el-radio>
                        <el-radio label='false'>拒绝</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label='驳回原因：' prop='desc' v-if="retreatForm.resource == 'false'">
                    <el-input style='width: 100%' type='textarea' v-model='retreatForm.desc'></el-input>
                </el-form-item>
                <!--                <el-form-item label='收益比例：' v-if="retreatForm.resource == 'true'" prop='incomeRatio'>-->
                <!--                    <el-input style='width: 200px' v-model='retreatForm.incomeRatio'></el-input>-->
                <!--                </el-form-item>-->
            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='handleCloseRetreat'>取 消</el-button>
                <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
            </span>
        </el-dialog>
        <mccCide ref="mccCode" @radioItem="radioThis"></mccCide>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import {
    exprotExcel,
    importTemplate,
    importDate,
    get,
    post,
    put,
    deleteFun,
    upload,
    postJson
} from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
import mccCide from '@/components/mccCodeTable/mccCide.vue';
import index from 'vuex';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import GridSelectU from '@/components/gridselect/index.vue';


export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        mccCide,
        GridSelectLi
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopStoreInfoList();
                this.getShopStoreInfoList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopStoreInfoList();
                this.getShopStoreInfoList();
                this.$emit('resetCheckState');
            }
        },
        //市
        'shopStoreInfo.licenseProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.shopStoreInfo.licenseCityId = '';
                    this.shopStoreInfo.licenseAreaId = '';
                    this.shopStoreInfo.licenseTownId = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'shopStoreInfo.licenseCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.shopStoreInfo.licenseAreaId = '';
                    this.shopStoreInfo.licenseTownId = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'shopStoreInfo.licenseAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.shopStoreInfo.licenseTownId = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },
        //市
        'shopStoreInfo.bankProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity2) {
                    this.shopStoreInfo.bankCityId = '';
                    this.shopStoreInfo.bankAreaId = '';
                    this.shopStoreInfo.bankTownId = '';
                } else {
                    this.getCity2 = !this.getCity2;
                }
                this.getAddress2(2,id)
            }, 25);
        },
        //区
        'shopStoreInfo.bankCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea2) {
                    this.shopStoreInfo.bankAreaId = '';
                    this.shopStoreInfo.bankTownId = '';
                } else {
                    this.getArea2 = !this.getArea2;
                }
                this.getAddress2(3,id)
            }, 30);
        },
        //社区
        'shopStoreInfo.bankAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street2) {
                    this.shopStoreInfo.bankTownId = '';
                } else {
                    this.street2 = !this.street2;
                }
                this.getAddress2(4,id)
            }, 35);
        },
        //市
        'shopStoreInfo.yinshengMerch.acqProvinceId'(id) {
            if(!id){
                return;
            }
            let str = ""
            for (let i = 0; i < this.provinceIdList3.length; i++) {
                if(this.provinceIdList3[i].code == id){
                    str = this.provinceIdList3[i].id
                }
            }
            setTimeout(() => {
                if (!this.getCity3) {
                    this.shopStoreOrginfo.yinshengMerch.acqCityId = '';
                    this.shopStoreOrginfo.yinshengMerch.acqAreaId = '';
                } else {
                    this.getCity3 = !this.getCity3;
                }
                this.getAddress3(2,str)
            }, 40);
        },
        // 区
        'shopStoreInfo.yinshengMerch.acqCityId'(id) {
            if(!id){
                return;
            }
            console.log("???")
            let str = ""
            for (let i = 0; i < this.cityIdList3.length; i++) {
                if(this.cityIdList3[i].code == id){
                    str = this.cityIdList3[i].id
                }
            }
            setTimeout(() => {
                if (!this.getArea3) {
                    this.shopStoreOrginfo.yinshengMerch.acqAreaId = '';
                } else {
                    this.getArea3 = !this.getArea3;
                }
                this.getAddress3(3,str)
            }, 50);
        },
        //市
        'shopStoreInfo.yinshengMerch.acqBankProvinceId'(id) {
            if(!id){
                return;
            }
            let str = ""
            for (let i = 0; i < this.provinceIdList3.length; i++) {
                if(this.provinceIdList3[i].code == id){
                    str = this.provinceIdList3[i].id
                }
            }
            setTimeout(() => {
                if (!this.getCity4) {
                    this.shopStoreInfo.yinshengMerch.acqBankCityId = '';
                    this.shopStoreInfo.yinshengMerch.acqBankAreaId = '';
                } else {
                    this.getCity4 = !this.getCity4;
                }
                this.getAddress4(2,str)
            }, 25);
        },
        //区
        'shopStoreInfo.yinshengMerch.acqBankCityId'(id) {
            if(!id){
                return;
            }
            let str = ""
            for (let i = 0; i < this.cityIdList4.length; i++) {
                if(this.cityIdList4[i].code == id){
                    str = this.cityIdList4[i].id
                }
            }
            setTimeout(() => {
                if (!this.getArea4) {
                    this.shopStoreInfo.yinshengMerch.acqBankAreaId = '';
                } else {
                    this.getArea4 = !this.getArea4;
                }
                this.getAddress4(3,str)
            }, 30);
        },
        tabs(val){
            // switch (val) {
            if(val == 'zero'){
                this.queryForm.thirdStatus='';
                this.currentPage = 1;
                this.getShopStoreInfoList();
                return
            }
            for (let i = 0; i < this.auditStatusList.length; i++) {
                if(val == 'status_'+i){
                    this.queryForm.thirdStatus = i;
                    this.currentPage = 1;
                    console.log(this.queryForm.thirdStatus)
                    this.getShopStoreInfoList();
                    break;
                }
            }
        },
    },
    data() {
        return {
            queryForm: {
                userId: '', //用户id
                storeId: '', //门店id
                orgType: '', //组织类型：1个人2企业 3个体
                licensePic: '', //营业执照图片
                licenseName: '', //营业执照名称
                licenseNumber: '', //统一社会信用代码
                licenseProvinceId: '', //营业执照注册省份
                licenseCityId: '', //营业执照注册城市
                licenseAreaId: '', //营业执照注册区域
                licenseTownId: '', //营业执照注册社区
                licenseAddress: '', //营业执照注册地址
                licenseIsPermanent: '', //营业执照是否长期有效：1是 0否
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机
                idCard: '', //身份证号
                idCardIsPermanent: '', //身份证是否长期有效：1是 0否
                idCardStartTime: '', //身份证有效限期起始日期
                idCardEndTime: '', //身份证有效期限截止日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行户主
                bankMobile: '', //银行预留手机号码
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankBranchCode: '', //行联号
                bankCode: '', //行联号
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户银行省份
                bankCityId: '', //开户银行城市
                bankAreaId: '', //开户银行区县
                bankTownId: '', //开户银行社区
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料：根据行业补充资料也不同，如烟酒店需要烟草经营许可证-废弃
                thirdStatus: ""
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopStoreInfoState: 'add',
            shopStoreInfoStates: {
                add: '新建进件信息',
                check: '查看进件信息',
                edit: '修改进件信息'
            },

            USER_code: USER,
            USER_search: USER_SEARCH,

            multipleSelection: [],
            shopStoreInfoList: [],
            shopStoreInfo: {
                userId: '', //用户id
                storeId: '', //门店id
                orgType: '', //组织类型：1个人2企业 3个体
                licensePic: '', //营业执照图片
                licenseName: '', //营业执照名称
                licenseNumber: '', //统一社会信用代码
                licenseProvinceId: '', //营业执照注册省份
                licenseCityId: '', //营业执照注册城市
                licenseAreaId: '', //营业执照注册区域
                licenseTownId: '', //营业执照注册社区
                licenseAddress: '', //营业执照注册地址
                licenseIsPermanent: '', //营业执照是否长期有效：1是 0否
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机
                idCard: '', //身份证号
                idCardIsPermanent: '', //身份证是否长期有效：1是 0否
                idCardStartTime: '', //身份证有效限期起始日期
                idCardEndTime: '', //身份证有效期限截止日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行户主
                bankMobile: '', //银行预留手机号码
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankBranchCode: '', //行联号
                bankCode: '', //行联号
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户银行省份
                bankCityId: '', //开户银行城市
                bankAreaId: '', //开户银行区县
                bankTownId: '', //开户银行社区
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料：根据行业补充资料也不同，如烟酒店需要烟草经营许可证-废弃
                yinshengMerch: {
                    mccCode: '',
                    mccName: '',
                    acqProvinceId: '',
                    acqCityId: '',
                    acqAreaId: '',
                    thirdStatus: 0,
                    acqBankProvinceId: '',
                    acqBankCityId: '',
                    acqBankAreaId: '',
                    acqPortalAccount: '',
                    acqPortalEmail: '',
                }
            },
            btnLoading: false,

            rules: {
                userId: [{ required: true, message: '用户id不能为空', trigger: 'blur' }],
                storeId: [{ required: true, message: '门店id不能为空', trigger: 'blur' }],
                orgType: [{ required: true, message: '组织类型：1个人2企业 3个体不能为空', trigger: 'blur' }],
                licensePic: [{ required: true, message: '营业执照图片不能为空', trigger: 'blur' }],
                licenseName: [{ required: true, message: '营业执照名称不能为空', trigger: 'blur' }],
                licenseNumber: [{ required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }],
                licenseProvinceId: [{ required: true, message: '营业执照注册省份不能为空', trigger: 'blur' }],
                licenseCityId: [{ required: true, message: '营业执照注册城市不能为空', trigger: 'blur' }],
                licenseAreaId: [{ required: true, message: '营业执照注册区域不能为空', trigger: 'blur' }],
                licenseTownId: [{ required: true, message: '营业执照注册社区不能为空', trigger: 'blur' }],
                licenseAddress: [{ required: true, message: '营业执照注册地址不能为空', trigger: 'blur' }],
                licenseIsPermanent: [{
                    required: true,
                    message: '营业执照是否长期有效：1是 0否 不能为空',
                    trigger: 'blur'
                }],
                licenseStartTime: [{ required: true, message: '营业执照有效开始日期不能为空', trigger: 'blur' }],
                licenseEndTime: [{ required: true, message: '营业执照有效结束日期不能为空', trigger: 'blur' }],
                licenseRange: [{ required: true, message: '营业执照经营范围不能为空', trigger: 'blur' }],
                personName: [{ required: true, message: '法人姓名不能为空', trigger: 'blur' }],
                personMobile: [{ required: true, message: '法人手机不能为空', trigger: 'blur' }],
                idCard: [{ required: true, message: '身份证号不能为空', trigger: 'blur' }],
                idCardIsPermanent: [{
                    required: true,
                    message: '身份证是否长期有效：1是 0否 不能为空',
                    trigger: 'blur'
                }],
                idCardStartTime: [{ required: true, message: '身份证有效限期起始日期不能为空', trigger: 'blur' }],
                idCardEndTime: [{ required: true, message: '身份证有效期限截止日期不能为空', trigger: 'blur' }],
                idCardFacade: [{ required: true, message: '身份证正面图片不能为空', trigger: 'blur' }],
                idCardBack: [{ required: true, message: '身份证背面图片不能为空', trigger: 'blur' }],
                idCardAddress: [{ required: true, message: '身份证地址不能为空', trigger: 'blur' }],
                bankAccount: [{ required: true, message: '银行账号不能为空', trigger: 'blur' }],
                bankHolder: [{ required: true, message: '银行户主不能为空', trigger: 'blur' }],
                bankMobile: [{ required: true, message: '银行预留手机号码不能为空', trigger: 'blur' }],
                bankCardFacade: [{ required: true, message: '银行卡正面图片不能为空', trigger: 'blur' }],
                bankCardBack: [{ required: true, message: '银行卡背面图片不能为空', trigger: 'blur' }],
                bankAccountVoucher: [{ required: true, message: '对公账户凭证不能为空', trigger: 'blur' }],
                bankName: [{ required: true, message: '银行名称不能为空', trigger: 'blur' }],
                bankBranchCode: [{ required: true, message: '行联号不能为空', trigger: 'blur' }],
                bankCode: [{ required: true, message: '行联号不能为空', trigger: 'blur' }],
                bankSubbranch: [{ required: true, message: '开户支行名称不能为空', trigger: 'blur' }],
                bankProvinceId: [{ required: true, message: '开户银行省份不能为空', trigger: 'blur' }],
                bankCityId: [{ required: true, message: '开户银行城市不能为空', trigger: 'blur' }],
                bankAreaId: [{ required: true, message: '开户银行区县不能为空', trigger: 'blur' }],
                bankTownId: [{ required: true, message: '开户银行社区不能为空', trigger: 'blur' }],
                isSign: [{ required: true, message: '是否签名 0否 1是不能为空', trigger: 'blur' }],
                signPic: [{ required: true, message: '签名图片不能为空', trigger: 'blur' }],
                contractUrl: [{ required: true, message: '合同地址不能为空', trigger: 'blur' }],
                otherInfor: [{
                    required: true,
                    message: '其他补充资料：根据行业补充资料也不同，如烟酒店需要烟草经营许可证-废弃不能为空',
                    trigger: 'blur'
                }],

                "yinshengMerch.mccCode": [{ required: true, message: '行业代码不能为空', trigger: 'blur' }],
                "yinshengMerch.mccName": [{ required: true, message: '行业名称不能为空', trigger: 'blur' }],
                "yinshengMerch.acqProvinceId": [{ required: true, message: '收单机构对应的省不能为空', trigger: 'blur' }],
                "yinshengMerch.acqCityId": [{ required: true, message: '收单机构对应的市不能为空', trigger: 'blur' }],
                "yinshengMerch.acqAreaId": [{ required: true, message: '收单机构对应的区不能为空', trigger: 'blur' }],
                "yinshengMerch.thirdStatus": [{ required: true, message: '进件状态不能为空', trigger: 'blur' }],
                "yinshengMerch.acqBankProvinceId": [{ required: true, message: '收单机构银行对应的省不能为空', trigger: 'blur' }], //收单机构对应的省
                "yinshengMerch.acqBankCityId": [{ required: true, message: '收单机构银行对应的市不能为空', trigger: 'blur' }], //收单机构对应的市
                "yinshengMerch.acqBankAreaId": [{ required: true, message: '收单机构银行对应的区不能为空', trigger: 'blur' }], //收单机构对应的区
                "yinshengMerch.acqPortalAccount": [{ required: true, message: '收单机构门户网站账号不能为空', trigger: 'blur' }],
                "yinshengMerch.acqPortalEmail": [{ required: true, message: '收单机构门户网站账号邮箱不能为空', trigger: 'blur' }],
            },

            srcList: [''],
            storeOrgTypeStatusEunmList: [],

            // 地址相关
            provinceIdList: [],
            cityIdList: [],
            areaIdList: [],
            streetIdList: [],
            getCity: false,//区别是不是get来的
            getArea: false,//区别是不是get来的
            street: false,

            cityIdList2:[],
            areaIdList2:[],
            streetIdList2: [],
            getCity2: false,//区别是不是get来的
            getArea2: false,//区别是不是get来的
            street2: false,

            getCity3: false,
            getArea3: false,
            provinceIdList3: [],
            cityIdList3: [],
            areaIdList3: [],

            getCity4: false,
            getArea4: false,
            cityIdList4: [],
            areaIdList4: [],

            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            imageSrc: '',

            auditStatusList: [],
            tabs: 'zero',

            retreatDialogVisible: false,
            auditId: '',
            applyRemarks: '',
            retreatRules: {
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }],
                incomeRatio: [{ required: true, message: '请填写门店收益比例', trigger: 'blur' }],
                resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
            },
            retreatForm: {
                resource: '',
                desc: '',
                incomeRatio: ''
            },
            fullscreenLoading: false,
        };
    },
    created() {
        this.getShopStoreInfoList();
        this.getEnum();
        this.getAddress(1);
        this.getAddress3(1, '0');
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        getSearchValueUser(val){
            this.queryForm.userId = val;
        },
        resetShopStoreInfoList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopStoreInfoList = [];
        },
        // 获取枚举
        getEnum(){
            get('/shop/utils/getEnum',{
                enumType: "store_org_type_status"
            }).then((res)=>{
                if(res.success){
                    this.storeOrgTypeStatusEunmList = res.enumList;
                }
            })

            // get('/mpp/utils/getEnum', {
            //     enumType: 'audit_status'
            // }).then((res) => {
            //     if(res.success){
            //         this.auditStatusEnumList = res.enumList;
            //     }
            // });

            get('/shop/utils/getEnum', {
                enumType: 'yinsheng_register_merchant_status'
            }).then((res) => {
                if(res.success){
                    this.auditStatusList = res.enumList;
                }
            });
        },
        returnStoreOrgTypeStatus(key){
            for (let i = 0; i < this.storeOrgTypeStatusEunmList.length; i++) {
                if(this.storeOrgTypeStatusEunmList[i].key == key){
                    return this.storeOrgTypeStatusEunmList[i].value
                }
            }
        },
        returnStoreOrgStatus(key){
            for (let i = 0; i < this.auditStatusList.length; i++) {
                if(this.auditStatusList[i].key == key){
                    return this.auditStatusList[i].value
                }
            }
        },
        // 获取对应地址
        getAddress(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList = array
                    }else if(type == 2){
                        this.cityIdList = array
                    }else if(type == 3){
                        this.areaIdList = array
                    }else if(type == 4){
                        this.streetIdList = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress2(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 2){
                        this.cityIdList2 = array
                    }else if(type == 3){
                        this.areaIdList2 = array
                    }else if(type == 4){
                        this.streetIdList2 = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress3(type, id=null) {
            get("/shop/yishengarea/findAll",{
                prCode: id
            }).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList3 = array
                    }else if(type == 2){
                        this.cityIdList3 = array
                    }else if(type == 3){
                        this.areaIdList3 = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress4(type, id=null) {
            get("/shop/yishengarea/findAll",{prCode: id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList4 = array
                    }else if(type == 2){
                        this.cityIdList4 = array
                    }else if(type == 3){
                        this.areaIdList4 = array
                    }
                    // else if(type == 4){
                    //     this.streetIdList3 = array
                    // }
                }
            })
        },
        radioThis(item){
            console.log( item)
            this.shopStoreInfo.yinshengMerch.mccCode = item.id
            this.shopStoreInfo.yinshengMerch.mccName = item.name
        },
        getMccCode(){
            get("/shop/yishengmcc/findAll").then((res)=>{
                if(res.success){
                    this.mccCodeList = res.list;
                    this.$nextTick(()=>{
                        this.$refs.mccCode.init(this.mccCodeList)
                    })
                }
            })
        },
        resetDialog() {
            this.shopStoreInfoState = 'add';
            this.showDialog = false;
            this.queryForm = {
                userId: '', //用户id
                storeId: '', //门店id
                orgType: '', //组织类型：1个人2企业 3个体
                licensePic: '', //营业执照图片
                licenseName: '', //营业执照名称
                licenseNumber: '', //统一社会信用代码
                licenseProvinceId: '', //营业执照注册省份
                licenseCityId: '', //营业执照注册城市
                licenseAreaId: '', //营业执照注册区域
                licenseTownId: '', //营业执照注册社区
                licenseAddress: '', //营业执照注册地址
                licenseIsPermanent: '', //营业执照是否长期有效：1是 0否
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机
                idCard: '', //身份证号
                idCardIsPermanent: '', //身份证是否长期有效：1是 0否
                idCardStartTime: '', //身份证有效限期起始日期
                idCardEndTime: '', //身份证有效期限截止日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行户主
                bankMobile: '', //银行预留手机号码
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankBranchCode: '', //行联号
                bankCode: '', //行联号
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户银行省份
                bankCityId: '', //开户银行城市
                bankAreaId: '', //开户银行区县
                bankTownId: '', //开户银行社区
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料：根据行业补充资料也不同，如烟酒店需要烟草经营许可证-废弃
            };
            this.getShopStoreInfoList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopStoreInfo = {
                userId: '', //用户id
                storeId: '', //门店id
                orgType: '', //组织类型：1个人2企业 3个体
                licensePic: '', //营业执照图片
                licenseName: '', //营业执照名称
                licenseNumber: '', //统一社会信用代码
                licenseProvinceId: '', //营业执照注册省份
                licenseCityId: '', //营业执照注册城市
                licenseAreaId: '', //营业执照注册区域
                licenseTownId: '', //营业执照注册社区
                licenseAddress: '', //营业执照注册地址
                licenseIsPermanent: '', //营业执照是否长期有效：1是 0否
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机
                idCard: '', //身份证号
                idCardIsPermanent: '', //身份证是否长期有效：1是 0否
                idCardStartTime: '', //身份证有效限期起始日期
                idCardEndTime: '', //身份证有效期限截止日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行户主
                bankMobile: '', //银行预留手机号码
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankBranchCode: '', //行联号
                bankCode: '', //行联号
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户银行省份
                bankCityId: '', //开户银行城市
                bankAreaId: '', //开户银行区县
                bankTownId: '', //开户银行社区
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料：根据行业补充资料也不同，如烟酒店需要烟草经营许可证-废弃
                yinshengMerch: {
                    mccCode: '',
                    mccName: '',
                    acqProvinceId: '',
                    acqCityId: '',
                    acqAreaId: '',
                    thirdStatus: 0,
                    acqBankProvinceId: '',
                    acqBankCityId: '',
                    acqBankAreaId: '',
                    acqPortalAccount: '',
                    acqPortalEmail: '',
                }
            };
        },
        submitForm() {
            let params = { ...this.shopStoreInfo };
            delete params.user
            delete params.store

            if (this.shopStoreInfoState == 'add') {
                this.$refs.shopStoreInfoForm.validate((valid, obj) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/storeinfo/add`, params).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreInfoList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }else{
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: this.mergeErrorArrays(obj),
                            type: 'warning',
                            duration: 2000
                        });
                    }
                });
            } else if (this.shopStoreInfoState == 'edit') {
                this.$refs.shopStoreInfoForm.validate((valid, obj) => {
                    if (valid) {
                        console.log('submit');
                        delete params.licenseProvince
                        delete params.licenseCity
                        delete params.licenseArea
                        delete params.licenseTown
                        delete params.bankProvince
                        delete params.bankCity
                        delete params.bankArea
                        delete params.bankTown
                        postJson(`/shop/storepayyinsheng/editYinshengData`, params).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreInfoList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }else{
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: this.mergeErrorArrays(obj),
                            type: 'warning',
                            duration: 2000
                        });
                    }
                });
            }
        },
        // 合并所有错误数组的方法
        mergeErrorArrays(errorObj) {
            let errors = [];
            // 遍历错误对象的所有属性
            for (const field in errorObj) {
                if (errorObj.hasOwnProperty(field) && Array.isArray(errorObj[field])) {
                    errors = errors.concat(errorObj[field]);
                }
            }
            return errors.map(item => item.message).join('<br>');
        },
        addShopStoreInfo() {
            this.showDialog = true;
            this.shopStoreInfoState = 'add';
        },
        checkShopStoreInfo(shopStoreInfoId) {
            console.log(shopStoreInfoId);
            this.currentShopStoreInfoId = shopStoreInfoId;

            this.getShopStoreInfoById();
            this.showDialog = true;
            this.shopStoreInfoState = 'check';
        },
        editShopStoreInfo(shopStoreInfoId) {
            console.log('shopStoreInfo', shopStoreInfoId);
            if (shopStoreInfoId) {
                this.currentShopStoreInfoId = shopStoreInfoId;
                this.getShopStoreInfoById();
            } else {
                this.shopStoreInfo = { ...this.shopStoreInfo, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopStoreInfoState = 'edit';
        },
        deleteShopStoreInfo(shopStoreInfoId) {
            let ids = '';
            if (shopStoreInfoId) {
                ids = shopStoreInfoId;
            } else {
                ids = this.multipleSelection.map((shopStoreInfo) => shopStoreInfo.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/storeinfo/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopStoreInfoList();
                            this.getShopStoreInfoList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopStoreInfoList() {
            this.resetShopStoreInfoList();
            this.getShopStoreInfoList();
        },
        getShopStoreInfoList(query = {}) {
            this.loading = true;
            get(`/shop/storepayyinsheng/findYinshengStoreList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopStoreInfoList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopStoreInfoById() {
            get(`/shop/storepayyinsheng/getYinshengStore`, { id: this.currentShopStoreInfoId }).then((res) => {
                if (res.success) {
                    this.shopStoreInfo = { ...this.shopStoreInfo, ...res.shopStoreInfo };
                    if(this.shopStoreInfo.yinshengMerch == null){
                        this.shopStoreInfo.yinshengMerch = {
                            mccCode: '',
                            mccName: '',
                            acqProvinceId: '',
                            acqCityId: '',
                            acqAreaId: '',
                            thirdStatus: 0,
                            acqBankProvinceId: '',
                            acqBankCityId: '',
                            acqBankAreaId: '',
                            acqPortalAccount: '',
                            acqPortalEmail: '',
                        }
                    }
                    this.getCity = true;
                    this.getArea = true;
                    this.street = true;
                    this.getCity2 = true;//区别是不是get来的
                    this.getArea2 = true;//区别是不是get来的
                    this.street2 = true;
                    this.getArea3 = true;
                    this.getCity3 = true;
                    this.getArea4 = true;
                    this.getCity4 = true;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopStoreInfoList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/storeinfo/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/storeinfo/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/storeinfo/importData`, formData);
            this.refreshShopStoreInfoList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopStoreInfoList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopStoreInfoList();
        },

        // 大图预览
        updateSrcList(src) {
            this.srcList[0] = src
        },
        getImage(url){
            this.imageSrc = url;
            this.srcList[0] = url;
            this.$refs.images.showViewer = true;
        },
        beforeImageUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        uploadImage21(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.licensePic = res.url;
                }
            });
        },
        uploadImage31(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.idCardFacade = res.url;
                }
            });
        },
        uploadImage32(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.idCardBack = res.url;
                }
            });
        },
        uploadImage41(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.bankCardFacade = res.url;
                }
            });
        },
        uploadImage42(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.bankCardBack = res.url;
                }
            });
        },
        uploadImage43(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.bankAccountVoucher = res.url;
                }
            });
        },
        uploadImage52(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.yinshengMerch.wxpayConfirmQrcode = res.url;
                }
            });
        },
        uploadImage54(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.yinshengMerch.alipayConfirmQrcode = res.url;
                }
            });
        },
        uploadImage61(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.signPic = res.url;
                }
            });
        },
        uploadImage62(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreInfo.contractUrl = res.url;
                }
            });
        },
        ShopStoreAudit(item) {
            console.log('applyRemarks', item);
            this.retreatDialogVisible = true;
            this.auditId = item.store.id;
            this.applyRemarks = item.store.remarks;
            this.retreatForm.desc = '';
        },
        // 审核取消按钮
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
            this.auditId = '';//关闭后清除点击的id
            this.applyRemarks = ''; //关闭后清除申请人的说明
            this.retreatForm.resource = '';//关闭后把选择的按钮置空
            this.retreatForm.desc = '';
            this.retreatForm.incomeRatio = '';
            console.log(this.retreatForm)
        },
        //审核确认按钮
        retreatSuccess(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    this.retreatDialogVisible = false;
                    let status = 1;
                    this.retreatForm.resource == 'true' ? status = 2 : status = 3;
                    get(`/shop/store/auditStore`, {
                        id: this.auditId,
                        status: status,
                        refuseReason: this.retreatForm.desc,
                        incomeRatio: this.retreatForm.incomeRatio
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.handleCloseRetreat();
                            this.getShopStoreInfoList()
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        },

        // 提交进件资料
        submitMerchantInfo(storeId){
            this.$confirm('确认资料核对无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storepayyinsheng/submitMerchantInfo',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })
            }).catch(() => {
            });
        },


    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.content{
    background-color: #fff;
    padding: 10px;
    height: 100%;
}

.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

::v-deep .el-upload--text {
    width: 130px;
    height: 130px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator {
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}


.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.page-content{
    height: calc(93% - 70px);
    padding: 0;
    border: 0;
}

.flex{
    display: flex;
    align-items: center;
    justify-content: center;
}
.active{
    color:#67C23A;
}
</style>